import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formatiert die übergebene Nummer in einen lokalisierten String zur Wiedergabe im Frontend
 */
@Pipe({ name: 'nbDecimal' })
export class NbDecimalPipe implements PipeTransform {
  transform(value: number): string {
    return value.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
}